import React from 'react';
import styles from './InfoPanel.module.css';
import {
	CheckmarkCircle,
	ExclamationMarkCircle,
	ExclamationMarkTriangle,
} from "./icons";

export type InfoPanelType = 'success' | 'warning' | 'error';

interface InfoPanelProps {
	type: InfoPanelType;
	message?: string;
	header?: string;
}

export const InfoPanel: React.FC<InfoPanelProps> = ({ type, message, header }) => {
	const getIcon = () => {
		switch (type) {
			case 'success':
				return <CheckmarkCircle width={28} height={28}/>;
			case 'warning':
				return <ExclamationMarkTriangle width={28} height={28} />;
			case 'error':
				return <ExclamationMarkCircle width={28} height={28} />;
		}
	};

	return (
		<div className={`${styles.alert} ${styles[type]}`} role="alert">
			<div className={styles.iconWrapper} aria-hidden="true">
				{getIcon()}
			</div>
			<div className={styles.content}>
				{header && <div className={styles.header}>{header}</div>}
				{message && <div className={styles.message}>{message}</div>}
			</div>
		</div>
	);
};